<template>
  <div class="zones-pg">
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ oopt.transName }} - {{ $t('Зоны') }}</h1>
      <div class="workroom-pg">
        <div class="bgw-pdg-20 observer-pg">
          <div class="add-npa-row">
            <ZoneAdd
              :ooptId="oopt.id"
              :ooptTotalArea="oopt.totalArea"
            >
              {{ $t('Добавить зону') }}
            </ZoneAdd>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="num-td">№</td>
                <td class="full-name-td">{{ $t('Название зоны') }}</td>
                <td class="full-name-td">{{ $t('Площадь') }} ({{$t('га')}})</td>
                <td class="full-name-td">%{{ $t('от') }} {{$t('Общая площадь')}}</td>
                <td class="full-name-td">{{ $t('Описание зоны')}}</td>
                <td class="td-action">{{ $t('Действия') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(zone, i) in oopt.ooptZones" :key="zone.id">
                <td class="num-td">{{ ++i }}</td>
                <td class="full-name-td">
                  <ZoneAdd
                    :ooptId="oopt.id"
                    :zoneEdit="true"
                    :ooptTotalArea="oopt.totalArea"
                    :zoneId="zone.id"
                  >
                    {{ zone.transName }} <span class="edit-icon"></span>
                  </ZoneAdd>
                </td>
                <td class="full-name-td">
                  {{ zone.area }}
                </td>
                <td class="full-name-td">
                  {{ zone.specificWeight }}
                </td>
                <td class="full-name-td">
                  {{zone.transDescription }}
                </td>
                <td class="td-action">
                  <v-btn class="btn-add btn-delete" @click.native.stop="deleteItem(zone.id)">
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="updateOopt"
            >
              <v-row :class="{ 'row-oopt-group': true }">
                <v-col cols="4" md="4">
                  <v-label>
                    {{ $t('НПА о зонировании') }}:
                    <fieldInfo :info="$t('НПА о зонировании')"/>
                  </v-label>
                </v-col>
                <v-col class="input-field" cols="8" md="8">
                  <v-row>
                    <v-col cols="11" md="11" class="right-side">
                      <div class="select-def">
                        <v-select
                          :items="refNpa"
                          return-value
                          item-value="id"
                          item-text="transName"
                          v-model="oopt.npaZoning"
                          outlined
                          dense
                          clearable
                        />
                      </div>
                    </v-col>
                    <NpaAdd
                      :title="$t('Создать, если его нет в списке')"
                      :ooptId="oopt.id" @updateNpaList="updateNpaList($event)"
                      :npaFromZones="true"
                    />
                  </v-row>
                </v-col>
              </v-row>
              <div class="form-action text-center">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Сохранить') }}
                </button>
                <button
                  type="button"
                  class="btn btn-default gray"
                  @click="onCancel"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </v-form>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Zone from '@/model/zone'
import OOPT from '@/model/oopt'
import ZoneAdd from '@/components/oopt/ZoneAdd'
import NpaAdd from '@/components/oopt/NpaAdd'
import fieldInfo from '@/components/app/fieldInfo'
import OoptDocument from '@/model/ooptDocument'

export default {
  components: {
    ZoneAdd,
    NpaAdd,
    fieldInfo
  },
  data: () => ({
    oopt: {},
    formData: {},
    breadcrumbs: [],
    refNpa: [],
    valid: true
  }),
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Zone.list(this.$route.params.id)
        .then((response) => {
          this.refNpa = response.data.refNpa
          this.oopt = { ...response.data.oopt }
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Рабочий кабинет'),
              disabled: false,
              href: '/my-organization'
            },
            { text: this.oopt.transName, disabled: false, href: '/my-organization?id=' + this.oopt.id },
            {
              text: this.$i18n.t('Зоны'),
              disabled: true
            }
          ]

          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // Обновление списка НПА
    updateNpaList (lists) {
      this.refNpa = lists
    },
    //  Обновление ООПТ
    updateOopt () {
      this.setLoading(true)
      this.formData = { npaZoning: this.oopt.npaZoning !== undefined ? this.oopt.npaZoning : null }
      OOPT.updateOopt(this.oopt.id, 'zone', this.formData)
        .then((response) => {
          if (response.status === 200) {
            this.$noty.success(this.$i18n.t('Успешно обновлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
            this.$router.push({
              name: 'zones',
              params: {
                id: this.oopt.id
              }
            })
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'MyOrganization',
        query: {
          id: this.oopt.id
        }
      })
    },
    deleteItem (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Zone.delete(id)
          .then((response) => {
            if (response.status === 200) {
              this.fetchData()
            }
            this.setLoading(false)
          })
          .catch((error) => {
            this.setLoading(false)
          })
      }
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
